import moment from 'moment/moment'
window.moment = moment



// WEBPACK FOOTER //
// ./src/core/utils/moment-setup.js